// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "05cd3d25b2a59f95e4fb" + ".chunk.js";
};